import type { ComponentTypes, WidgetComponent } from 'api/types';
import type { RefObject } from 'react';

export const scrollToTheBottom = (behavior: ScrollBehavior) => {
  const lastChild = document.querySelector(
    '.js-scrollable-messages-container > :last-child',
  );

  if (lastChild === null) {
    return;
  }

  lastChild.scrollIntoView({ behavior, block: 'end' });
};

export const isSafari = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const safariNotChromeRegex = /^(?!.*chrome\.).*safari.*$/;
  return safariNotChromeRegex.test(userAgent.toLowerCase());
};

export const setFocusOnFormSubmit = (
  ref: RefObject<HTMLFormElement> | null,
): void => {
  const formPreviousSibling =
    ref?.current && ref.current.previousElementSibling;
  if (formPreviousSibling) (formPreviousSibling as HTMLElement).focus();
};

export const noUserActionsLeft = (
  currentWidgetComponent: WidgetComponent,
): boolean => {
  /**
   * When the widget component is on form/buttons even after finishing the action
   * (isSent) - no actions left
   * When the widget component is on non-user action widget such as
   * article/intent/message - no actions left
   */
  const currentWidgetComponentType = currentWidgetComponent?.component_type;
  const userActionList: ComponentTypes[] = ['form', 'buttons'];
  if (userActionList.includes(currentWidgetComponentType)) {
    return !!currentWidgetComponent.isSent;
  }
  const noActionList: ComponentTypes[] = [
    'article',
    'article_suggestion',
    'text_message',
  ];
  return noActionList.includes(currentWidgetComponentType);
};
